import { render, staticRenderFns } from "./IconShare.vue?vue&type=template&id=63dfb7b1&scoped=true&"
import script from "./IconShare.vue?vue&type=script&lang=js&"
export * from "./IconShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dfb7b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63dfb7b1')) {
      api.createRecord('63dfb7b1', component.options)
    } else {
      api.reload('63dfb7b1', component.options)
    }
    module.hot.accept("./IconShare.vue?vue&type=template&id=63dfb7b1&scoped=true&", function () {
      api.rerender('63dfb7b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconShare.vue"
export default component.exports